// src/RequestAccessPage.js
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { functions } from './firebase';
import { httpsCallable } from 'firebase/functions';
import {
    TextField, Button, Select, MenuItem, FormControl, InputLabel,
    FormGroup, FormControlLabel, Checkbox, Typography, Box, Grid, Paper, Alert, Container, Link
} from '@mui/material';
import MaskedInput from './MaskedInput';

const ZONAS = [
    "Saúde", "Morumbi", "Aclimação", "Ipiranga", "Mooca", "Carrão", 
    "Itaquera", "Guarulhos", "Santo André", "São Bernardo do Campo", 
    "São Caetano do Sul", "Litoral"
];

function RequestAccessPage() {
    const initialState = {
        nome: '', email: '', cnpj: '', cpf: '', rg: '', endereco: '', creci: '', telefone: '',
        tipoUsuario: 'autonomo', zonaAtuacao: []
    };
    const [formData, setFormData] = useState(initialState);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    };

    const handleZoneChange = (e) => {
        const { value, checked } = e.target;
        setFormData(prevState => ({ 
            ...prevState, 
            zonaAtuacao: checked 
                ? [...prevState.zonaAtuacao, value] 
                : prevState.zonaAtuacao.filter(zone => zone !== value)
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); setMessage('');
        if (formData.zonaAtuacao.length === 0) {
            setError("Selecione pelo menos uma zona de atuação.");
            return;
        }
        setIsSubmitting(true);
        try {
            // Envio via Cloud Function — rate limiting e validações feitos no servidor
            const submitRequest = httpsCallable(functions, 'submitAccessRequest');
            await submitRequest(formData);
            setMessage('Sua solicitação foi enviada com sucesso! Nossa equipe analisará e entrará em contato.');
            setFormData(initialState);
        } catch (err) {
            const msg = err?.message || 'Falha ao enviar solicitação.';
            setError(msg);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Container component="main" maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3} sx={{ p: { xs: 2, md: 4 } }}>
                <Typography variant="h4" component="h1" gutterBottom align="center">Solicitação de Cadastro</Typography>
                <Typography variant="body1" align="center" gutterBottom>Preencha para se candidatar. Sua solicitação será analisada.</Typography>

                { !message ? (
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}><FormControl fullWidth><InputLabel>Tipo de Parceiro</InputLabel><Select name="tipoUsuario" value={formData.tipoUsuario} label="Tipo de Parceiro" onChange={handleChange}><MenuItem value="autonomo">Autônomo</MenuItem><MenuItem value="imobiliaria">Imobiliária</MenuItem></Select></FormControl></Grid>
                            <Grid item xs={12} sm={6}><TextField fullWidth name="nome" label="Nome completo / Razão Social" value={formData.nome} onChange={handleChange} required /></Grid>
                            <Grid item xs={12} sm={6}><TextField fullWidth name="email" type="email" label="E-mail" value={formData.email} onChange={handleChange} required /></Grid>
                            
                            <Grid item xs={12}><TextField fullWidth required name="telefone" label="Telefone / WhatsApp" value={formData.telefone} onChange={handleChange} InputProps={{ inputComponent: MaskedInput, inputProps: { mask: '(00) 00000-0000' } }} /></Grid>

                            {formData.tipoUsuario === 'autonomo' && (
                                <>
                                    <Grid item xs={12} sm={6}><TextField fullWidth required name="cpf" label="CPF" value={formData.cpf} onChange={handleChange} InputProps={{ inputComponent: MaskedInput, inputProps: { mask: '000.000.000-00' } }} /></Grid>
                                    <Grid item xs={12} sm={6}><TextField fullWidth name="rg" label="RG" value={formData.rg} onChange={handleChange} InputProps={{ inputComponent: MaskedInput, inputProps: { mask: '00.000.000-0' } }} /></Grid>
                                </>
                            )}
                            {formData.tipoUsuario === 'imobiliaria' && (
                                <Grid item xs={12}><TextField fullWidth required name="cnpj" label="CNPJ" value={formData.cnpj} onChange={handleChange} InputProps={{ inputComponent: MaskedInput, inputProps: { mask: '00.000.000/0000-00' } }} /></Grid>
                            )}
                            
                            <Grid item xs={12} sm={6}><TextField fullWidth name="creci" label="CRECI" value={formData.creci} onChange={handleChange} required /></Grid>
                            {/* CORREÇÃO: Endereço não é mais obrigatório */}
                            <Grid item xs={12} sm={6}><TextField fullWidth name="endereco" label="Endereço (Opcional)" value={formData.endereco} onChange={handleChange} /></Grid>
                            
                            <Grid item xs={12}><FormControl component="fieldset" variant="standard"><Typography component="legend">Zona de Atuação:</Typography><FormGroup row>{ZONAS.map(zona => <FormControlLabel key={zona} control={<Checkbox checked={formData.zonaAtuacao.includes(zona)} onChange={handleZoneChange} value={zona} />} label={zona} />)}</FormGroup></FormControl></Grid>
                            <Grid item xs={12}><Button type="submit" variant="contained" fullWidth disabled={isSubmitting} sx={{ mt: 2 }}>Enviar Solicitação</Button></Grid>
                            {error && <Grid item xs={12}><Alert severity="error">{error}</Alert></Grid>}
                        </Grid>
                    </Box>
                ) : (
                    <Alert severity="success" sx={{ mt: 4, fontSize: '1.1rem' }}>{message}</Alert>
                )}
                
                <Box sx={{ mt: 3, textAlign: 'center' }}><Link component={RouterLink} to="/login">Voltar para o Login</Link></Box>
            </Paper>
        </Container>
    );
}
export default RequestAccessPage;